import React from 'react';
import AtPacketProviderOfficeSelect from '../../AtPacketProviderOfficeSelect';

/**
 * DSCC status (under Diagnoses). Filled in by the SC after intake.
 * - 4 status options (Pending, Ineligible Dx, Ineligible $, Enrolled).
 * - When Pending or Enrolled, a "DSCC Office" provider+office picker (community-partner type).
 * - A "verify" badge shows when the value was migrated from older AT packets (clears on save).
 */
function DsccSection({ formData, handleChange, dsccStatuses, onDsccOfficeChange, dsccOfficeLabel }) {
  const opts = dsccStatuses || [];
  const selected = opts.find((o) => String(o.id) === String(formData.dscc_status_id));
  const code = selected?.code || '';
  const showOffice = code === 'Pending' || code === 'ENR';
  return (
    <div className="form-section">
      <h3 className="section-title">DSCC</h3>
      <div className="form-grid form-grid-3">
        <div className="form-group">
          <label htmlFor="dscc_status_id">DSCC Status</label>
          <select
            id="dscc_status_id"
            name="dscc_status_id"
            value={formData.dscc_status_id || ''}
            onChange={handleChange}
          >
            <option value="">—</option>
            {opts.map((o) => (
              <option key={o.id} value={o.id}>{o.display_name || o.code}</option>
            ))}
          </select>
          {formData.dscc_migrated_uncertain ? (
            <span
              style={{ display: 'inline-block', marginTop: 4, fontSize: '0.8rem', color: '#b15b00', fontWeight: 500 }}
              title="This DSCC status was migrated from older AT packets and may not be exact — please verify and save."
            >
              DSCC migrated — please verify
            </span>
          ) : null}
        </div>
      </div>
      {showOffice ? (
        <div className="form-group">
          <label htmlFor="dscc_office">DSCC Office</label>
          <AtPacketProviderOfficeSelect
            id="dscc_office"
            typeCode="CP"
            providerId={formData.dscc_location_provider_id}
            providerSiteId={formData.dscc_location_site}
            currentSelectionLabel={dsccOfficeLabel}
            onChange={onDsccOfficeChange}
            emptyLabel="Click and type to search community partner and office…"
          />
        </div>
      ) : null}
    </div>
  );
}

export default DsccSection;
